import styles from './Extensions.module.css';
import TextCard from "../TextCard/TextCard";
import CustomSlider from '../CustomSlider/CustomSlider';

export default function Extensions() {
    const elements = Array.from({ length: 100 }, (v, k) =>  <TextCard  seeMore='Saiba Mais' title='Título do Projeto' description='Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado desde o século XVI, quando um impressor desconhecido pegou uma bandeja de tipos e os embaralhou para fazer um livro de ' type='extension'/>);

    return (
        <CustomSlider elements={elements}/>
    );
}